// extracted by mini-css-extract-plugin
export default {"alert":"InformationStatus-module__alert___43zkZ"};